import styled from 'styled-components'

import { COLOURS, BREAKPOINTS } from 'resources'
import { protectHeaderScribble } from 'resources/images'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${COLOURS.neutralBlack};
  background-size: auto 50%;
  overflow: hidden;
  min-height: 150px;

  @media (max-width: ${BREAKPOINTS.md}) {
    min-height: 150px;
    background-size: auto 50%;
  }

  @media (min-width: ${BREAKPOINTS.lg}) {
    min-height: 290px;
    background-size: auto 65%;
  }

  @media (min-width: ${BREAKPOINTS.xl}) {
    min-height: 330px;
    background-size: auto 70%;
  }
`

export const Scribble = styled.img.attrs({
  src: protectHeaderScribble,
})`
  display: none;
  z-index: 0;
  position: absolute;

  @media (min-width: ${BREAKPOINTS.md}) {
    display: block;
    bottom: -90px;
    left: -140px;
    height: 210px;
    width: 270px;
    transform: rotate(20deg);
  }

  @media (min-width: ${BREAKPOINTS.lg}) {
    display: block;
    top: -355px;
    left: 50%;
    height: auto;
    width: auto;
    transform: translateX(-50%) rotate(102.5deg) scale(0.55, 1.3);
  }

  @media (min-width: ${BREAKPOINTS.xl}) {
    display: block;
    top: -352px;
    left: 50%;
    height: auto;
    width: auto;
    transform: translateX(-50%) rotate(102.5deg) scale(0.65, 1.6);
  }
`

export const Content = styled.div`
  margin: auto 0 0;
`

export const Title = styled.div`
  z-index: 1;
  font-family: 'Druk', sans-serif;
  font-size: 60px;
  line-height: 1;
  color: ${COLOURS.white};
  text-align: center;

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 70px;
  }

  @media (min-width: ${BREAKPOINTS.lg}) {
    font-size: 90px;
    text-align: left;
  }
`
export const TitleAccent = styled.span`
  color: ${COLOURS.secondaryPurple2};
`

export const TitleButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${BREAKPOINTS.lg}) {
    flex-direction: row;
  }
`
